export default "__VITE_ASSET__Bgvcs5SG__"